import {FileProps} from '../Model'

export type SortField = 'name' | 'date'
export type SortDirection = 'asc' | 'desc'

export const sortFiles = (
  files: Array<FileProps>,
  field: SortField,
  direction: SortDirection
): Array<FileProps> => {
  const sorted = [...files].sort((a, b) => {
    if (field === 'date') {
      return a.modifiedAt.localeCompare(b.modifiedAt)
    }
    return a.basename.toLowerCase().localeCompare(b.basename.toLowerCase())
  })

  return direction === 'desc' ? sorted.reverse() : sorted
}
